var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfo16 = function SvgIconInfo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.5,
    stroke: "var(--color-purple500, #872AB0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-purple500, #872AB0)",
    d: "M8 11V7M8 6V5"
  })));
};
export default SvgIconInfo16;